import { SET_TODAYS_DATE } from '../actions/today';
export var today = function today() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : new Date();
  var action = arguments.length > 1 ? arguments[1] : undefined;
  switch (action.type) {
    case SET_TODAYS_DATE:
      return action.todaysDate;
    default:
      return state;
  }
};